import React from "react";
import dpd from "../../../../../assets/img/career/dpd.png";
import GetPackages from "../api/GetPackages";
import { Fragment } from "react";
import PostApiData from "../api/PostApiData";
import GetExistDoc from "../api/GetExistDoc";
/* Loga dopravců */
import Dpd from "../../../../../assets/img/career/dpd.png";
import Cp from "../../../../../assets/img/career/cp.png";
import Dhl from "../../../../../assets/img/career/dhl.png";
import Gls from "../../../../../assets/img/career/gls.png";
import Mess from "../../../../../assets/img/career/mess.png";
import Ppl from "../../../../../assets/img/career/ppl.png";
import Tnt from "../../../../../assets/img/career/tnt.png";
import Toptrans from "../../../../../assets/img/career/toptrans.jpg";
import Ups from "../../../../../assets/img/career/ups.png";
import Wedo from "../../../../../assets/img/career/wedo.png";
import Zasilkovna from "../../../../../assets/img/career/zasilkovna.png";
import Britex from "../../../../../assets/img/career/favicon.png";

class ReceptionSearch extends React.Component {
  timer = null;
  timerApi = null;
  state = {
    value: "",
    packet: null,
    packets: [],
    loading: false,
    apidata: false,
    apidatacount: 0,
    cardsdata: false,
    apidatalist: [],
    apidatares: null,
  };

  ApiData = async (ship) => {
    var _res = await PostApiData({
      ...this.props,
      shipments: ship,
      type: null,
      numAtCard: null,
      deviceSN: null,
      insuranceNo: null,
    });
    if (_res.status === 200) {
      this.props.apidata(_res.data);
      this.setState({ apidatacount: _res.data.length, apidata: false });
    } else {
      this.setState({ apiDataList: [], apidata: false, apidatacount: 0 });
    }
  };

  carierLogo(e) {
    try {
      if (e.toString().indexOf("_") > -1) e = e.split("_")[0];
    } catch {}

    switch (e) {
      case "DHL":
        return Dhl;
      case "DPD":
        return Dpd;
      case "CP":
        return Cp;
      case "GLS":
        return Gls;
      case "PPL":
        return Ppl;
      case "TNT":
        return Tnt;
      case "MESS":
        return Mess;
      case "TOPTRANS":
        return Toptrans;
      case "UPS":
        return Ups;
      case "INTIME":
        return Wedo;
      case "WEDO":
        return Wedo;
      case "Zasilkovna":
        return Zasilkovna;
      default:
        return Britex;
    }
  }

  getExistDocNoForShip = async (id) => {
    var _res = await GetExistDoc({ ...this.props, idPack: id.value });
    if (_res.status === 200) {
      if (_res.data.length > 0) {
        this.props.setAny({
          docs: _res.data,
          card: _res.data[0],
          cardSetDetail: true,
          hideShip: true,
          hideCard: true,
        });
      }

      if (_res.data.length >= 0) {
        this.setState({ apidata: true });
        this.ApiData(id.PackCode);
      }
    }
  };

  searchPackage = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ loading: true });
      var _res = await GetPackages({ ...this.props, packagefilter: e });
      if (_res.status === 200) {
        this.setState({
          packet: _res.data.length === 1 ? _res.data : null,
          packets: _res.data,
          loading: false,
        });
        if (_res.data.length === 1) {
          this.getExistDocNoForShip(_res.data[0]);
          this.props.set(_res.data[0]);
        }
      } else {
        this.setState({
          packet: null,
          packets: [],
          loading: false,
        });
      }
    }, 500);
  };

  componentDidMount() {}

  render() {
    const { Bs, VARIANT, SIZE, Icon } = this.props;
    return (
      <>
        {this.state.packet && (
          <>
            <Bs card bg={VARIANT.WHITE}>
              <Bs cardheader className="bg-white">
                <Bs row>
                  <Bs
                    col
                    xs={12}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <Bs strong>Zásilka</Bs>
                    {this.props.hideShip && (
                      <Icon
                        fimaximize
                        data-tip="Zobrazit"
                        className="c-secondary cursor-pointer"
                        onClick={this.props.hide}
                      />
                    )}
                    {!this.props.hideShip && (
                      <Icon
                        fiminimize
                        data-tip="Skrýt"
                        className="c-secondary cursor-pointer"
                        onClick={this.props.hide}
                      />
                    )}
                    <Icon
                      fatimes
                      data-tip="Zavřít tuto dopravu"
                      className="c-secondary cursor-pointer"
                      onClick={() => {
                        this.setState({
                          value: "",
                          packet: null,
                          packets: [],
                          loading: false,
                          apidata: false,
                          cardsdata: false,
                          apidatalist: [],
                          apidatares: null,
                        });
                        this.props.reset();
                      }}
                    />
                  </Bs>
                </Bs>
              </Bs>
              {!this.props.hideShip && (
                <Bs cardbody>
                  <Bs row className="mb-2">
                    <Bs col xs={2} className="d-flex align-items-center me-4">
                      <Bs
                        image
                        style={{ width: "60px" }}
                        src={this.carierLogo(this.state.packet[0]?.TrnspCode)}
                      />
                    </Bs>
                    <Bs col xs={6}>
                      <Bs row>
                        <Bs strong>{this.state.packet[0]?.PackCode}</Bs>
                      </Bs>
                      <Bs row>
                        <Bs small>
                          {new Date(
                            this.state.packet[0]?.DateCreate.split("T")[0]
                          ).toLocaleDateString()}
                        </Bs>
                      </Bs>
                    </Bs>
                  </Bs>
                  {!this.state.apidata && (
                    <Bs row>
                      <Bs small className="text-muted">
                        {this.state.apidatacount > 0
                          ? "Nalezeno v datech (Počet přístrojů: " +
                            this.state.apidatacount +
                            ")"
                          : ""}
                      </Bs>
                    </Bs>
                  )}
                  {this.state.apidata && (
                    <>
                      <Bs
                        brtxasyncselect
                        isLoading={this.state.apidata}
                        disabled={this.state.apidata}
                        minLength={2}
                        selected={this.state.apidatares}
                        promptText="Piš pro vyhledání..."
                        searchText="Hledám předvyplněné data..."
                        emptyLabel="Nic jsem nenašel."
                        onChange={(e) => {
                          this.setState({
                            apidatares: e,
                          });
                        }}
                        onSearch={this.searchPackage}
                        options={this.state.cardCodes}
                        placeholder="Hledám předvyplněné data..."
                        renderMenuItemChildren={(option, props) => (
                          <Fragment>
                            <span>{option.label}</span>
                          </Fragment>
                        )}
                      />
                    </>
                  )}
                </Bs>
              )}
              <Bs cardfooter className="bg-white">
                <Bs row>
                  <Bs col xs={12} className="d-flex justify-content-end">
                    <Bs
                      button
                      variant={VARIANT.TRANSPARENT}
                      size={SIZE.SM}
                      data-tip="Vytvořit neshodu"
                      className="me-2"
                    >
                      Vytvořit neshodu
                    </Bs>
                    <Bs
                      button
                      variant={VARIANT.TRANSPARENT}
                      size={SIZE.SM}
                      data-tip="Prázdná zásilka"
                    >
                      Prázdná zásilka
                    </Bs>
                    <Bs
                      button
                      variant={VARIANT.TRANSPARENT}
                      size={SIZE.SM}
                      data-tip="Uzavřít zásilku"
                    >
                      Uzavřít zásilku
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </>
        )}
        {!this.state.packet && (
          <>
            <Bs row>
              <Bs col xs={12} className="mb-2 d-flex justify-cintent-end">
                <Bs
                  button
                  variant={VARIANT.SUCCESS}
                  size={SIZE.SM}
                  onClick={() => {
                    this.setState({
                      packet: [{
                        PackCode: "OSOBNĚ",
                        TrnspCode: "OSOBNĚ",
                        PackDate: this.props.DateTimeNow(),
                        DateCreate: this.props.DateTimeNow(),
                      }],
                    });
                    console.log(this.props.DateTimeNow());
                    this.props.set({
                      PackCode: "OSOBNĚ",
                      TrnspCode: "OSOBNĚ",
                      PackDate: this.props.DateTimeNow(),
                      DateCreate: this.props.DateTimeNow(),
                    });
                    
                  }}
                >
                  Osobně
                </Bs>
              </Bs>
            </Bs>

            <Bs inputgroup>
              <Bs inputgrouptext id="basic-addon1">
                Číslo zásilky
              </Bs>
              <Bs
                brtxasyncselect
                id="searchPackage"
                isLoading={this.state.loading}
                minLength={3}
                promptText="Piš pro vyhledání..."
                searchText="Hledám požadovaný balík..."
                emptyLabel="Nic jsem nenašel."
                selected={this.state.packet}
                onChange={(e) => {
                  this.setState({ packet: e });
                  this.props.set(e[0]);
                  this.getExistDocNoForShip(e[0]);
                }}
                onSearch={this.searchPackage}
                options={this.state.packets}
                placeholder="Začni psát nebo načti balík"
                renderMenuItemChildren={(option, props) => (
                  <Fragment>
                    <Bs row>
                      <Bs
                        col
                        xs={3}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <Bs
                          image
                          src={this.carierLogo(option.TrnspCode)}
                          width={50}
                        />
                      </Bs>
                      <Bs col xs={9}>
                        <Bs row className="mb-2">
                          <Bs col xs={4} className="me-2">
                            <strong>Dopravce</strong>
                          </Bs>
                          <Bs col xs={8}>
                            <span>{option.TrnspCode}</span>
                          </Bs>
                        </Bs>
                        <Bs row className="mb-2">
                          <Bs col xs={4} className="me-2">
                            <strong>Číslo dopravy</strong>
                          </Bs>
                          <Bs col xs={8}>
                            <span>
                              {option.label.lenght > 15
                                ? option.label.substring(9, 14)
                                : option.label}
                            </span>
                          </Bs>
                        </Bs>
                        <Bs row>
                          <Bs col xs={4} className="me-2">
                            <strong>Datum obdržení</strong>
                          </Bs>
                          <Bs col xs={8}>
                            <span>
                              {new Date(option.DateCreate).toLocaleDateString()}
                            </span>
                          </Bs>
                        </Bs>
                      </Bs>
                    </Bs>
                  </Fragment>
                )}
              />
            </Bs>
          </>
        )}
      </>
    );
  }
}

export default ReceptionSearch;
